module.exports = __webpack_public_path__ + "static/media/Мухаметшин А. и др. (ММ).4ff619fb.pdf";